// Third Parth
import React from 'react';

// Components
import { IconButton } from '../../../components/buttons';
import { InfoTooltip } from '../../../components/tooltips';

// Utils
import { BMOi18n } from '../../../../utils/bmo-gif/constants';
import { getTotalGifPortfolioAllocation } from '../../../../utils/bmo-gif/index';
import { PROVINCES, ACCOUNT_TYPES } from '../../../../utils/constants';
import { formatMessage } from '../../../../utils/i18n';
import { getKeyByValue } from '../../../../utils/objects';
import { getAge } from '../../../../utils/time';
import ComparisonContact from '@/types/comparison-contact';
import BMOGIFPortfolio from '@/types/bmo-gif/bmo-gif-portfolio';

type Props = {
  locale: string;
  contact: ComparisonContact;
  onEditContact: (id?: string) => void;
  portfolio: BMOGIFPortfolio;
  readOnly?: boolean;
};

const BMOContactInfo = ({ contact, locale, onEditContact, portfolio, readOnly }: Props) => {
  const baseAge = getAge(portfolio.dob, undefined, portfolio.purchaseDate);

  const provinceKey = getKeyByValue(PROVINCES, contact.province);
  const accountTypeKey = getKeyByValue(ACCOUNT_TYPES, contact.accountType);

  // Using this to show/hide tooltip since it only makes sense if they can see the purchase date
  const portfolioIsFull = getTotalGifPortfolioAllocation(portfolio) === 100;

  return (
    <div className="bmo-contact-info-v2 d-flex flex-column" data-private data-dd-privacy="mask">
      <div className="info-header d-flex align-items-center">
        <div className="flex-fill">
          <i className="icon-user" />

          {BMOi18n[locale].CLIENT_INFO}
        </div>

        {!readOnly && <IconButton icon="pencil" onClick={() => onEditContact(contact._id)} />}
      </div>

      <div className="name">
        <span>{contact.fullName}</span>
      </div>

      <div className="bmo-contact-details-v2">
        <span className="age">
          {`${BMOi18n[locale].PURCHASE_AGE} ${baseAge || 0}`}
          <span className="info-icon">{portfolioIsFull && <InfoTooltip message={BMOi18n[locale].AGE_CALCULATION_INFO} />}</span>
        </span>

        <span className="province">{contact.province && formatMessage(`Provinces.${provinceKey}`)}</span>

        <span className="account-type">{contact.accountType && formatMessage(`AccountTypes.${accountTypeKey}`)}</span>

        <span className="registered-account-type">{contact.registeredAccountType && BMOi18n[locale][contact.registeredAccountType]}</span>
      </div>
    </div>
  );
};

export default BMOContactInfo;
